'use client';

import { c as _c } from "react/compiler-runtime";
import { Button as ButtonPrimitive } from '@base-ui/react/button';
import { type VariantProps } from 'class-variance-authority';
import { Spinner } from '@repo/ui/components/spinner';
import { cn } from '@repo/ui/lib/utils';
// Relative on purpose: the package-specifier form resolves via the exports map
// for consumers, but Storybook's `@repo/ui` → src alias maps it to a
// nonexistent src/button-variants — which broke every Vercel ui build.
import { buttonVariants } from './button-variants';
function Button(t0) {
  const $ = _c(26);
  let children;
  let className;
  let disabled;
  let loading;
  let loadingText;
  let props;
  let render;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      className,
      variant: t1,
      size: t2,
      loading,
      loadingText,
      children,
      disabled,
      render,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = disabled;
    $[4] = loading;
    $[5] = loadingText;
    $[6] = props;
    $[7] = render;
    $[8] = t1;
    $[9] = t2;
  } else {
    children = $[1];
    className = $[2];
    disabled = $[3];
    loading = $[4];
    loadingText = $[5];
    props = $[6];
    render = $[7];
    t1 = $[8];
    t2 = $[9];
  }
  const variant = t1 === undefined ? "default" : t1;
  const size = t2 === undefined ? "default" : t2;
  const t3 = loading ? "" : undefined;
  const t4 = disabled || loading;
  let t5;
  if ($[10] !== className || $[11] !== size || $[12] !== variant) {
    t5 = cn(buttonVariants({
      variant,
      size,
      className
    }));
    $[10] = className;
    $[11] = size;
    $[12] = variant;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const t6 = render === undefined ? undefined : false;
  let t7;
  if ($[14] !== children || $[15] !== loading || $[16] !== loadingText) {
    t7 = loading ? <><Spinner className="size-4" />{loadingText ?? children}</> : children;
    $[14] = children;
    $[15] = loading;
    $[16] = loadingText;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== props || $[19] !== render || $[20] !== t3 || $[21] !== t4 || $[22] !== t5 || $[23] !== t6 || $[24] !== t7) {
    t8 = <ButtonPrimitive data-slot="button" data-loading={t3} disabled={t4} className={t5} render={render} nativeButton={t6} {...props}>{t7}</ButtonPrimitive>;
    $[18] = props;
    $[19] = render;
    $[20] = t3;
    $[21] = t4;
    $[22] = t5;
    $[23] = t6;
    $[24] = t7;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  return t8;
}
export { Button, buttonVariants };